import backgroundAudioActions from '../actions/BackgroundAudioActions';

export default (state = {}, action) => {
    switch (action.type) {
    case backgroundAudioActions.types.BACKGROUND_AUDIO_RESTORE_AUDIO_STATUS:
        return action.backgroundAudio;

    case backgroundAudioActions.types.BACKGROUND_AUDIO_SET_SECTION_STATUS:
        return {
            ...state,
            [action.audioContentItemId]: {
                ...state[action.audioContentItemId],
                status: action.status,
            },
        };

    case backgroundAudioActions.types.BACKGROUND_AUDIO_SET_INTRO_PLAYED:
        return {
            ...state,
            isIntroPlayed: action.isIntroPlayed,
        };

    case backgroundAudioActions.types.BACKGROUND_AUDIO_SET_SECTION_POSITION:
        return {
            ...state,
            [action.audioContentItemId]: {
                ...state[action.audioContentItemId],
                position: action.position,
            },
        };

    case backgroundAudioActions.types.BACKGROUND_AUDIO_SET_TIMES_REPLAY_REQUESTED:
        return {
            ...state,
            [action.audioContentItemId]: {
                ...state[action.audioContentItemId],
                timesReplayRequested: action.timesReplayRequested,
            },
        };

    case backgroundAudioActions.types.BACKGROUND_AUDIO_SET_RECENT_PLAYING_AUDIO:
        return {
            ...state,
            recentPlayingAudioId: action.audioContentItemId,
        };

    default:
        return state;
    }
};
